import React from "react"
import * as Icon from "react-feather"
import { BiPaperPlane } from "react-icons/bi";
import { BiCheckShield } from "react-icons/bi";
import { AiOutlineProject } from "react-icons/ai";
import { FaFileInvoiceDollar, FaHelicopter } from 'react-icons/fa';
import { CgDebug } from 'react-icons/cg';
import { MdOutlineAdminPanelSettings } from 'react-icons/md';
import { BsTranslate } from "react-icons/bs";

const navigationConfig = [
  {
    id: "home",
    title: "Dashboard",
    type: "item",
    icon: <Icon.Home size={20} />,
    permissions: ["Pilot", "HEMS", "Dashboard"],
    navLink: "/"
  },
  {
    id: "map",
    title: "Mapa",
    type: "item",
    icon: <Icon.Map size={20} />,
    permissions: ["Administrator", "Superuser"],
    navLink: "/mapView"
  },
  {
    id: "pilotcard",
    title: "Uživatel",
    type: "item",
    icon: <Icon.Clipboard size={20} />,
    permissions: ["Pilot", "HEMS"],
    navLink: "/pilotcard"
  },
  {
    id: "activity",
    title: "Docházka",
    type: "item",
    icon: <Icon.UserCheck size={20} />,
    permissions: ["Administrator", "HEMS"],
    navLink: "/office/activity"
  },
  {

        id: "todo",
        title: "TO DO",
        type: "item",
        icon: <Icon.CheckSquare size={20} />,
        permissions: ["Administrator", "HEMS"],
        navLink: "/todo/:filter",
        filterBase: "/todo/my"
  },
  {

    id: "notificationCenter",
    title: "Notifikace",
    type: "item",
    icon: <Icon.Mail size={20} />,
    permissions: ["Administrator", "HEMS"],
    navLink: "/notificationCenter/:filter",
    filterBase: "/notificationCenter/inbox"
},
{

  id: "emergency",
  title: "Emergency",
  type: "item",
  icon: <Icon.Mail size={20} />,
  permissions: ["Superuser"],
  navLink: "/emergency"
},
{
  id: "office",
  title: "Office",
  type: "collapse",
  icon: <Icon.Inbox size={20} />,
  permissions: ["Administrator", "HEMS"],
  children: [
    {
      id: "clients",
      title: "Kontakty",
      type: "item",
      icon: <Icon.User size={20} />,
      permissions: ["Administrator"],
      navLink: "/office/contacts"
    },
    {
      id: "order",
      title: "Zakázky",
      type: "item",
      icon: <Icon.Aperture size={20} />,
      permissions: ["Administrator"],
      navLink: "/office/orders"
    },
    {
      id: "qualificationsroot",
      title: "Kvalifikace",
      type: "item",
      icon: <Icon.FileText size={20} />,
      permissions: ["Administrator"],
      navLink: "/office/qualifications",
    },
    {
      id: "technics",
      title: "Technika",
      type: "item",
      icon: <BiPaperPlane size={20} />,
      permissions: ["Administrator", "HEMS"],
      navLink: "/office/technics"
    },
    {
      id: "dayplan",
      title: "Plánování",
      type: "item",
      icon: <Icon.Calendar size={20} />,
      permissions: ["Administrator", "editor"],
      navLink: "/office/dayplan"
    },
    {
      id: "flights",
      title: "Letové záznamy obecné",
      type: "item",
      icon: <Icon.Book size={20} />,
      permissions: ["Administrator", "HEMS"],
      navLink: "/office/flights"
    },
    {
      id: "data",
      title: "Číselníky",
      type: "item",
      icon: <Icon.Database size={20} />,
      permissions: ["Administrator"],
      navLink: "/office/data"
    },
    {
      id: "invoice",
      title: "Faktury",
      type: "item",
      icon: <FaFileInvoiceDollar size={20} />,
      permissions: ["Administrator"],
      navLink: "/office/invoice"
    }
  ]
},
{
  id: "hems",
  title: "HEMS",
  type: "collapse",
  icon: <FaHelicopter size={20} />,
  permissions: ["Administrator", "HEMS"],
  children: [
    {
      id: "bases",
      title: "Základny",
      type: "item",
      icon: <Icon.Target size={20} />,
      permissions: ["Administrator"],
      navLink: "/hems/bases"
    },
    {
      id: "pilotPlanning",
      title: "Přehled směn",
      type: "item",
      icon: <Icon.Calendar size={20} />,
      permissions: ["Administrator"],
      navLink: "/hems/pilotPlanning"
    },
    {
      id: "planning",
      title: "Plánování",
      type: "item",
      icon: <Icon.Calendar size={20} />,
      permissions: ["Administrator"],
      navLink: "/hems/planning"
    },
    {
      id: "shifts",
      title: "Přehled pilot",
      type: "item",
      icon: <Icon.Calendar size={20} />,
      permissions: ["HEMS", "Pilot"],
      navLink: "/hems/shifts"
    }
  ]
},
{
  id: "database",
  title: "Databaze",
  type: "collapse",
  icon: <Icon.Database size={20} />,
  permissions: ["Administrator"],
  children: [
    {
      id: "aerodrome",
      title: "Aerodrome",
      type: "item",
      icon: <Icon.MapPin size={20} />,
      permissions: ["Administrator"],
      navLink: "/database/aerodrome"
    },
    {
      id: "airspace",
      title: "Airspace",
      type: "item",
      icon: <Icon.Globe size={20} />,
      permissions: ["Administrator"],
      navLink: "/database/airspace"
    },
    {
      id: "airspaceaup",
      title: "Airspace AUP",
      type: "item",
      icon: <Icon.AlertCircle size={20} />,
      permissions: ["Administrator"],
      navLink: "/database/airspaceaup"
    },
    {
      id: "atis",
      title: "Atis",
      type: "item",
      icon: <Icon.FileText size={20} />,
      permissions: ["Administrator"],
      navLink: "/database/atis"
    },
    {
      id: "camera",
      title: "Kamery",
      type: "item",
      icon: <Icon.Camera size={20} />,
      permissions: ["Administrator"],
      navLink: "/database/camera"
    },
    {
      id: "cameralist",
      title: "Seznamy kamer",
      type: "item",
      icon: <Icon.List size={20} />,
      permissions: ["Administrator"],
      navLink: "/database/cameralist"
    },
    {
      id: "notam",
      title: "NOTAM",
      type: "item",
      icon: <Icon.AlertCircle size={20} />,
      permissions: ["Administrator"],
      navLink: "/database/notam"
    },
    {
      id: "meteo",
      title: "Meteo",
      type: "item",
      icon: <Icon.Cloud size={20} />,
      permissions: ["Administrator"],
      navLink: "/database/meteo"
    }
  ]
},
{
  id: "unitgroup",
  title: "Units",
  type: "collapse",
  icon: <Icon.Users size={20} />,
  permissions: ["Administrator"],
  children: [
    {
      id: "unitcategory",
      title: "Unit category",
      type: "item",
      icon: <Icon.List size={20} />,
      permissions: ["Administrator"],
      navLink: "/units/category"
    },
    {
      id: "units",
      title: "Units",
      type: "item",
      icon: <Icon.Users size={20} />,
      permissions: ["Administrator"],
      navLink: "/units/list"
    },
    {
      id: "unitGroup",
      title: "Units skupiny",
      type: "item",
      icon: <Icon.Users size={20} />,
      permissions: ["Administrator"],
      navLink: "/units/unitGroup"
    },
    {
      id: "unitView",
      title: "Unit view",
      type: "item",
      icon: <Icon.Globe size={20} />,
      permissions: ["Administrator"],
      navLink: "/units/unitView"
    },
  ]
},
{
  id: "eventgroup",
  title: "Events",
  type: "collapse",
  icon: <Icon.Target size={20} />,
  permissions: ["Administrator"],
  children: [
    {
      id: "events",
      title: "Events",
      type: "item",
      icon: <Icon.List size={20} />,
      permissions: ["Administrator"],
      navLink: "/events/list"
    },
  ]
},
{
  id: "administration",
  title: "Administrace",
  type: "collapse",
  icon: <MdOutlineAdminPanelSettings size={20} />,
  permissions: ["Administrator"],
  children: [
    {
      id: "users",
      title: "Uživatelé",
      type: "item",
      icon: <Icon.Users size={20} />,
      permissions: ["Administrator"],
      navLink: "/administration/users"
    }, 
    {
      id: "newuser",
      title: "Nový uživatel",
      type: "item",
      icon: <Icon.UserPlus size={20} />,
      permissions: ["Administrator"],
      navLink: "/administration/newuser"
    }, 
    {
      id: "usergroups",
      title: "Skupiny a práva",
      type: "item",
      icon: <BiCheckShield size={20} />,
      permissions: ["Administrator"],
      navLink: "/administration/usergroups"
    },  
    {
      id: "completelog",
      title: "Log",
      type: "item",
      icon: <Icon.List size={20} />,
      permissions: ["Administrator"],
      navLink: "/administration/completelog"
    },
    {
      id: "chatTranslator",
      title: "Chat translator",
      type: "item",
      icon: <BsTranslate size={20} />,
      permissions: ["Superuser", "Administrator"],
      navLink: "/administration/chatTranslator"
    }, 
    {
      id: "pushNotification",
      title: "Test notifikací",
      type: "item",
      icon: <Icon.CloudLightning size={20} />,
      permissions: ["Superuser"],
      navLink: "/administration/pushNotification"
    }, 
    {
      id: "other",
      title: "Ostatní",
      type: "item",
      icon: <CgDebug size={20} />,
      permissions: ["Superuser"],
      navLink: "/administration/other"
    },
    {
      id: "gridTool",
      title: "Grid tool",
      type: "item",
      icon: <Icon.Tool size={20} />,
      permissions: ["Superuser"],
      navLink: "/administration/gridTool"
    },
    /*
    {
      id: "rights",
      title: "Rights",
      type: "item",
      icon: <Icon.List size={20} />,
      permissions: ["Administrator"],
      navLink: "/administration/rights"
    },
    {
      id: "groups",
      title: "Groups",
      type: "item",
      icon: <Icon.List size={20} />,
      permissions: ["Administrator"],
      navLink: "/administration/groups"
    },*/
  ]

}
]

export default navigationConfig
